import React from 'react';
import '../Footer/Footer.css';
import { useDarkMode } from '../../context/DarkModeContext';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

function Footer() {
  const { darkMode, setDarkMode } = useDarkMode();

  return (
    <footer className={`footer${darkMode ? ' dark-mode' : ''}`}>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-row">
            <p>&copy; {new Date().getFullYear()} Jose Ayala — Infrastructure Engineer</p>
            <button className="footer-theme-toggle" onClick={() => setDarkMode(!darkMode)}>
              {darkMode ? <Brightness7Icon fontSize="small" /> : <Brightness4Icon fontSize="small" />}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
